// extracted by mini-css-extract-plugin
export default {"selector":"search-result-page-size-select_selector__nr3Vw"};